<template>
  <div class="layout-container">
    <Header />
    <main class="layout-content">
      <router-view />
    </main>
    <Footer ref="footerRef" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Header from '@/components/layout/Header.vue';
import Footer from '@/components/layout/Footer.vue';

const footerRef = ref<InstanceType<typeof Footer> | null>(null);

// 暴露触发底部动画的方法
const triggerFooterAnimation = () => {
  footerRef.value?.triggerFooterAnimation();
};

defineExpose({
  triggerFooterAnimation
});
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layout-content {
  flex: 1;
}
</style>